import React from 'react'
import Layout from '../../Layout/Layout'
import raw1 from '../../images/raw1.PNG'
import raw2 from '../../images/raw2.PNG'

const Raw_materials_research = () => {
  return (
     <Layout>
        <div className='uk-container'>
            <div>
                <h2 className='light uk-text-bold uk-margin-xlarge-top'>Lecture Paper: Raw Materials Research and Development Council (RMRDC)  </h2>
                 <h3 className='light uk-text-bold '>Topic: Mapping Nigeria's Raw Material Diversity: Geospatial Analysis and Resource Distribution</h3>
                </div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
               Moolu Venture Lab's CEO, Prince Ogbonna, was invited by the
                Raw Materials Research and Development Council (RMRDC) to 
                deliver a significant lecture paper on "Mapping Nigeria's
                 Raw Material Diversity: Geospatial Analysis and Resource
                  Distribution." This high-level engagement, conducted in
                   the presence of the Director-General and senior council
                    directors, underscored Moolu Venture Lab's role as a 
                    trusted innovation support organization seeking to inspire
                     institutions managing Nigeria's critical resources.
</p>

                <p className='light'>
                    Prince Ogbonna’s engaging session explored Nigeria’s rich
                     mineral and agricultural resource potential through the
                      modern lens of Geospatial Technologies and Artificial
                       Intelligence (AI). A key takeaway from the presentation 
                       was the revelation that Nigeria possesses untapped 
                       mineral potential valued at over $700 billion, representing
                        a massive opportunity for industrial growth and economic
                         diversification away from oil dependence. This illustrated
                          the transformative power of AI and geospatial technology 
                          in advancing critical sectors.
                </p>
               </div>

                <div className='uk-width-1-2@s'>
                 <img src={raw1} />
               </div>
            </div>







             <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src={raw2} />
               </div>

                <div className='uk-width-1-2@s'>
                          <p className='light'>
                        At Moolu Venture Lab, the organization perceives its mandate as one that involves
                         actively driving modernization by introducing cutting-edge technologies and 
                         knowledge to core government institutions like RMRDC. The Lab finds it highly
                          encouraging to witness government leaders demonstrating a genuine "hunger 
                          for growth and knowledge". This kind of institutional openness is essential
                           for translating vast resource potential into tangible economic impact for 
                           the entire nation.

                            </p>
                  
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default Raw_materials_research